export default {
  styleOverrides: {
    root: {
      // borderRadius: '5px 5px 0px 0px',
      boxShadow: 'none',
    }
  }
}
